import { SubscriptionStatus } from './types';

export const SUBSCRIPTION_LABELS: Record<SubscriptionStatus, string> = {
  NONE: '—',
  TRIALING: 'Trial',
  ACTIVE: 'Active',
  EXPIRED: 'Expired'
};

export function subscriptionLabel(status?: SubscriptionStatus | null): string {
  return status ? (SUBSCRIPTION_LABELS[status] ?? status) : '—';
}
